<template>
  <div class="forget-page">
    <div class="container w-wrapper">
      <div class="back" @click="goBack()">返回首页</div>
      <div class="title">
        <span v-if="step === 1">设置密码</span>
        <span v-else>输入密码</span>
      </div>
      <div class="form-box">
        <el-form
            v-show="step === 1"
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleFormRef1"
            label-width="100px"
            class="demo-ruleForm">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model.trim="ruleForm1.phone" placeholder="请输入" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码" prop="smsCode">
            <div class="flex-row-h-center">
              <div style="flex: 1;">
                <el-input v-model.trim="ruleForm1.smsCode" placeholder="请输入" maxlength="6"></el-input>
              </div>
              <div class="flex-row-h-end" style="width: 150px;margin-left: 10px;">
                <el-button @click="getSMSVerifyCodeApi()">{{
                    countdown > 0 ? `${countdown}秒后重试` : '获取短信验证码'
                  }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="btn-box">
              <el-button v-if="step === 1" style="width: 200px" type="primary" @click="onNext()">下一步</el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-form
            v-show="step === 2"
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleFormRef2"
            label-width="100px"
            class="demo-ruleForm">
          <el-form-item label="新密码" prop="password">
            <el-input v-model.trim="ruleForm2.password" placeholder="新密码" show-password maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model.trim="ruleForm2.confirmPassword" placeholder="确认密码" show-password
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn-box">
              <el-button style="width: 200px" type="default" @click="onPre()">上一步</el-button>
              <el-button style="width: 200px" type="primary" @click="submitForm()">完成</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {encryptECB} from '@/utils/parsing'
import {
  checkSmsCode,
  getSMSVerifyCode, resetPassword
} from "@/apis/login";
import {isMobile, isPassword} from "@/utils/validate";

export default {
  name: "audit-process",
  data() {
    return {
      countdown: 0, // 倒计时
      timer: null, // 定时器
      step: 1,
      checkSmsKey: '', // 检验短信验证码的key
      smsCode: '', // 短信验证码
      smsKey: '', // 短信验证码的key
      ruleForm1: {
        phone: '',
        code: '',
        smsCode: ''
      },
      rules1: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
        ],
        smsCode: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      },
      ruleForm2: {
        password: '',
        confirmPassword: '',
      },
      rules2: {
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
        ],
        confirmPassword: [
          {required: true, message: '请输入确认密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 返回首页
    goBack() {
      this.$router.replace({
        path: '/home'
      })
    },
    // 获取短信验证码
    getSMSVerifyCodeApi() {
      if (this.ruleForm1.phone.length !== 11) {
        return this.$message.warning('请输入正确的11位手机号码')
      }
      if (!isMobile(this.ruleForm1.phone)) {
        return this.$message.warning('请输入正确的11位手机号码')
      }
      if (this.countdown > 0) return; // 防抖处理
      getSMSVerifyCode({
        phone: encryptECB(this.ruleForm1.phone)
      }).then((res) => {
        this.smsCode = res.data.code
        this.smsKey = res.data.key
        this.$message({
          message: '验证码已发送，请注意查收',
          type: 'success'
        });
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown <= 0) {
            clearInterval(this.timer);
          } else {
            this.countdown--;
          }
        }, 1000);
      }).catch(() => {
        this.countdown = 0;
      });
    },
    onPre() {
      this.step = 1
    },
    // 下一步
    onNext() {
      this.$refs.ruleFormRef1.validate((valid) => {
        if (valid) {
          this.checkSmsCodeApi()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 忘记密码-校验短信验证码
    checkSmsCodeApi() {
      checkSmsCode({
        "code": this.ruleForm1.smsCode,
        "key": this.smsKey,
        "phone": encryptECB(this.ruleForm1.phone)
      }).then(res => {
        this.checkSmsKey = res.data.key
        this.step = 2
      })
    },
    // 确认修改密码
    submitForm() {
      this.$refs.ruleFormRef2.validate((valid) => {
        if (valid) {
          if (this.ruleForm2.password !== this.ruleForm2.confirmPassword) {
            return this.$message.error('两次输入的密码不一致')
          }
          if (!isPassword(this.ruleForm2.password)) {
            return this.$message.error('密码格式不正确，密码只能包含大小写字母+数字，长度≥8位')
          }
          const loading = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            text: '拼命加载中...',
            background: 'rgba(0, 0, 0, 0.5)',
            customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
          })
          resetPassword({
            key: this.checkSmsKey,
            password: encryptECB(this.ruleForm2.password)
          }).then(res => {
            console.log(res)
            this.$message({
              message: '密码重置成功',
              type: 'success'
            })
            this.$refs.ruleFormRef1.resetFields()
            this.$refs.ruleFormRef2.resetFields()
            setTimeout(() => {
              const VUE_APP_ORG_URL = process.env.VUE_APP_ORG_URL
              window.open(VUE_APP_ORG_URL, '_self')
            }, 2000)
          }).finally(() => {
            loading.close()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
  }
}
</script>

<style lang="scss" scoped>
.forget-page {
  overflow: hidden;
  height: 100vh;
}

.container {
  position: relative;
  margin: 80px auto;
  height: calc(100% - 160px);
  padding: 30px;
  background-color: #ffffff;

  .back {
    position: absolute;
    top: 20px;
    left: 20px;
    color: #409EFF;
    cursor: pointer;
  }

  .form-box {
    flex: 1;
    overflow-y: auto;
    margin: 20px 0 0;
    padding: 30px 240px 20px;
  }

  .btn-box {
    margin-top: 40px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 100px;
  }
}
</style>